import { type PropsWithChildren, type CSSProperties } from 'react';

import { View } from '../common/View';

type FloatingActionBarProps = PropsWithChildren & {
  style: CSSProperties;
};

export function FloatingActionBar({ style, children }: FloatingActionBarProps) {
  return (
    <View
      style={{
        backgroundColor: 'var(--color-floatingActionBarBackground)',
        color: 'var(--color-floatingActionBarText)',
        position: 'fixed',
        bottom: 10,
        margin: '0 10px',
        width: '95vw',
        height: 60,
        zIndex: 100,
        borderRadius: 8,
        border: `1px solid var(--color-floatingActionBarBorder)`,
        ...style,
      }}
    >
      {children}
    </View>
  );
}
